module.exports = __webpack_public_path__ + "static/media/sneakpeek-message-background.134aec06.png";